import { useState, useEffect } from "react";
import { useGetDeviceOperationLogsforReportMutation } from "../../store/storageRoles/devicesSharedApi";
import { useGetDealerRolesDeviceOperationLogsforReportMutation } from "../../store/dealerRoles/devicesApi";
import useAuth from "../useAuth";
import logger from "../../utils/logger";

export const useDeviceOperationReportData = (deviceId, token) => {
  const { auth } = useAuth();
  const isDealer = auth?.role === "dealer";
  const [input, setInput] = useState({
    type: "OperationInfo",
  });
  const [date, setDate] = useState(null);
  const [dateSecond, setDateSecond] = useState(null);
  const [Datas, setDatas] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [info, setInfo] = useState(null);

  const [
    getStorageDeviceOperationLogsforReport,
    { data: storageData, isLoading: storageIsLoading, error: storageError },
  ] = useGetDeviceOperationLogsforReportMutation();
  const [
    getDealerDeviceOperationLogsforReport,
    { data: dealerData, isLoading: dealerIsLoading, error: dealerError },
  ] = useGetDealerRolesDeviceOperationLogsforReportMutation();

  const getDeviceOperationLogsforReport = isDealer
    ? getDealerDeviceOperationLogsforReport
    : getStorageDeviceOperationLogsforReport;
  const data = isDealer ? dealerData : storageData;
  const isLoading = isDealer ? dealerIsLoading : storageIsLoading;
  const error = isDealer ? dealerError : storageError;

  const handleGetLogData = async (productName = null) => {
    if (!deviceId || !token || !date || !dateSecond) {
      return;
    }

    try {
      // Önceki verileri temizle
      setDatas([]);

      const requestData = {
        token: token,
        id: deviceId,
        createdInfo: date,
        createdInfoSecond: dateSecond,
      };

      const result = await getDeviceOperationLogsforReport(
        requestData
      ).unwrap();

      if (result && result.data) {
        setDatas(result.data);
      }
    } catch (error) {
      logger.error("❌ Operation Report Error:", error);
    }
  };

  // Data değiştiğinde Datas'ı güncelle
  useEffect(() => {
    if (data && data.data) {
      setDatas(data.data);
    }
  }, [data]);

  return {
    input,
    setInput,
    date,
    setDate,
    dateSecond,
    setDateSecond,
    Datas,
    selectedDate,
    setSelectedDate,
    info,
    setInfo,
    isLoading,
    error,
    handleGetLogData,
  };
};
